import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import { styled } from "@mui/system";
import { convertTimestampToDate } from "../../../utils/helpers";
const Info = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: "14px",
  fontFamily: "Urbane-Light",
  fontWeight: 700,
  marginBottom: theme.spacing(1),
}));

const ClientDetailsDialogue = ({
  open,
  onClose,
  candidate_statusinfo,
  reportName,
  candidateData,
  DateFindBy,
}) => {
  // const getStatusColor = (status) => {
  //   switch (status.toLowerCase()) {
  //     case "interested":
  //       return "primary";
  //     case "active":
  //       return "info";
  //     case "hired":
  //       return "success";
  //     case "inactive":
  //       return "error";
  //     case "rejected":
  //       return "error";
  //     case "offer extended":
  //       return "warning";
  //     case "blocked":
  //       return "error";
  //     case "engaged":
  //       return "primary";
  //     case "interview": // New case added for interview
  //       return "secondary"; // Specify your desired color here
  //     default:
  //       return "default";
  //   }
  // };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "interested":
        return "primary";
      case "active":
        return "info";
      case "hired":
        return "success";
      case "inactive":
      case "rejected":
      case "blocked":
        return "error";
      case "offer extended":
        return "warning";
      case "engaged":
        return "primary";
      case "interview":
        return "secondary";
      default:
        return null; // Return null for undefined cases
    }
  };
  const formatDate = (date) => {
    return format(new Date(date), "MM/dd/yyyy");
  };

  const hiredStatus = candidate_statusinfo
    .filter((statusInfo) => statusInfo.status.toLowerCase() === DateFindBy)
    .sort((a, b) => b.cdate.$date - a.cdate.$date)[0];
  const hiringDate = hiredStatus ? formatDate(hiredStatus.cdate.$date) : "N/A";
  const candidateStatus = hiredStatus ? hiredStatus.status : "N/A";
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "17px",
          maxWidth: "500px",
        },
      }}
    >
      <DialogTitle sx={{ padding: 0 }}>
        <Box
          sx={{
            backgroundColor: "#250258",
            padding: "12px 16px",
            position: "relative",
            borderRadius: "16px 16px 0 0",
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "white", fontWeight: "bold", fontSize: "18px" }}
          >
            Details
          </Typography>
          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
            }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ margin: "15px" }}>
        <Info>Client Information</Info>
        <Box
          sx={{
            overflow: "hidden",
            marginBottom: "16px",
            padding: "1px",
            backgroundColor: "#fff",
          }}
        >
          <Table
            sx={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <TableBody>
              {[
                { label: reportName + " date", value: hiringDate },
                {
                  label: "Candidate status",
                  value:
                    candidateStatus?.charAt(0).toUpperCase() +
                    candidateStatus?.slice(1),
                },
                {
                  label: "Name",
                  value:
                    hiredStatus?.client_name ||
                    candidateData?.client_name ||
                    "N/A",
                },
                {
                  label: "Email",
                  value:
                    hiredStatus?.client_email ||
                    candidateData?.client_email ||
                    "N/A",
                },
                {
                  label: "Contact number",
                  value:
                    hiredStatus?.client_mobileno ||
                    candidateData?.client_mobileno ||
                    "N/A",
                },
              ].map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "#424242",
                      padding: "8px 16px",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.label}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#757575",
                      padding: "8px 16px",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "12px",
                    }}
                  >
                    {row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        <Info>Recruiter Information</Info>
        <Box
          sx={{
            overflow: "hidden",
            marginBottom: "16px",
            padding: "1px",
            backgroundColor: "#fff",
          }}
        >
          <Table
            sx={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <TableBody>
              {[
                {
                  label: "Name",
                  value: candidateData?.recruiter_name || "N/A",
                },
                {
                  label: "Email",
                  value: candidateData?.recruiter_email || "N/A",
                },
                {
                  label: "Contact number",
                  value: candidateData?.recruiter_mobileno || "N/A",
                },
              ].map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "#424242",
                      padding: "8px 16px",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.label}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#757575",
                      padding: "8px 16px",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "12px",
                    }}
                  >
                    {row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>

        {/* Search Person Information */}
        <Info>Search Person Information</Info>
        <Box
          sx={{
            overflow: "hidden",
            marginBottom: "16px",
            padding: "1px",
            backgroundColor: "#fff",
          }}
        >
          <Table
            sx={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <TableBody>
              {[
                {
                  label: "Search by",
                  value: candidateData?.searchperson || "N/A",
                },
                {
                  label: "Email",
                  value: candidateData?.searchperson_email || "N/A",
                },
                {
                  label: "Contact number",
                  value: candidateData?.searchperson_mobileno || "N/A",
                },
              ].map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      fontWeight: 600,
                      color: "#424242",
                      padding: "8px 16px",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.label}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#757575",
                      padding: "8px 16px",
                      borderBottom: "1px solid #f0f0f0",
                      fontSize: "12px",
                    }}
                  >
                    {row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Table sx={{ width: "100%", borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    padding: "8px",
                    fontWeight: "bold",
                    textAlign: "left",
                    borderBottom: "2px solid #ddd",
                    color: "#333",
                    fontSize: "14px",
                    boxSizing: "border-box", // Ensure box-sizing for consistent width
                  }}
                >
                  Process Date
                </TableCell>
                <TableCell
                  sx={{
                    padding: "8px",
                    fontWeight: "bold",
                    textAlign: "left",
                    borderBottom: "2px solid #ddd",
                    color: "#333",
                    fontSize: "14px",
                    boxSizing: "border-box", // Ensure box-sizing for consistent width
                  }}
                >
                  Stages
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {candidate_statusinfo && candidate_statusinfo.length > 0 ? (
                candidate_statusinfo.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        color: "#555",
                        fontSize: "14px",
                        boxSizing: "border-box", // Consistent box-sizing
                      }}
                    >
                      {convertTimestampToDate(item.cdate.$date)}
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "8px",
                        borderBottom: "1px solid #ddd",

                        alignItems: "center",
                        gap: "8px",
                        boxSizing: "border-box", // Consistent box-sizing
                      }}
                    >
                      {/* Bullet Point */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            mx: "5px",
                            width: "9px",
                            height: "9px",
                            borderRadius: "50%",
                            backgroundColor: (theme) =>
                              theme.palette[getStatusColor(item.status)]
                                ? theme.palette[getStatusColor(item.status)]
                                    .light
                                : "#ccc", // Use light variant of the color
                          }}
                        ></Box>
                        {/* Status Text */}
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            fontSize: "14px",
                            color: (theme) =>
                              theme.palette[getStatusColor(item.status)]
                                ? theme.palette[getStatusColor(item.status)]
                                    .light
                                : "#555", // Use light variant of the color
                          }}
                        >
                          {item.status.toUpperCase()}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      textAlign: "center",
                      padding: "12px",
                      fontSize: "14px",
                      color: "#555",
                      boxSizing: "border-box", // Ensure box-sizing consistency
                    }}
                  >
                    No Status Available!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ClientDetailsDialogue;



// 1737157056828


// 1737157056843